import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { Drawer } from 'src/components/widgets/drawer';
import theme from 'src/shared/theme';
import { SkeletonHeaderContent, SkeletonHeaderWrapper, SkeletonSectionWrapper, SkeletonStatusBarWrapper } from './styled';

export const SidePanelSkeleton: FC<{ onClose: () => void }> = ({ onClose }) => (
    <Drawer isOpen={true} onClose={onClose} header={<SidePanelSkeletonHeader />} width={580}>
        <SidePanelSkeletonStatusBar />
        {[0, 1, 2].map((index) => (
            <SidePanelSkeletonSection key={index} />
        ))}
    </Drawer>
);

const SidePanelSkeletonHeader: FC = () => (
    <SkeletonHeaderWrapper>
        <ContentLoader speed={2} width={56} height={56} backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
            <rect x='0' y='0' rx='8' ry='8' width='56' height='56' />
        </ContentLoader>
        <SkeletonHeaderContent>
            <ContentLoader speed={2} width='100%' height='38' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
                <rect x='0' y='0' rx='4' ry='4' width='60%' height='18' />
                <rect x='0' y='26' rx='4' ry='4' width='35%' height='12' />
            </ContentLoader>
        </SkeletonHeaderContent>
    </SkeletonHeaderWrapper>
);

const SidePanelSkeletonStatusBar: FC = () => (
    <SkeletonStatusBarWrapper>
        <ContentLoader speed={2} width='100%' height='22' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
            <rect x='0' y='0' rx='6' ry='6' width='80' height='22' />
            <rect x='88' y='0' rx='12' ry='12' width='70' height='22' />
        </ContentLoader>
    </SkeletonStatusBarWrapper>
);

const SidePanelSkeletonSection: FC = () => (
    <SkeletonSectionWrapper>
        <ContentLoader speed={2} width='100%' height='79' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
            <rect x='0' y='0' rx='4' ry='4' width='120' height='10' />
            <rect x='0' y='20' rx='50%' ry='50%' width='8' height='8' />
            <rect x='18' y='18' rx='4' ry='4' width='70%' height='13' />
            <rect x='0' y='41' rx='50%' ry='50%' width='8' height='8' />
            <rect x='18' y='39' rx='4' ry='4' width='55%' height='13' />
            <rect x='0' y='62' rx='50%' ry='50%' width='8' height='8' />
            <rect x='18' y='60' rx='4' ry='4' width='40%' height='13' />
        </ContentLoader>
    </SkeletonSectionWrapper>
);
